import React from 'react';
import cn from 'classnames';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { theme } from '../../../theme';
import { GoTabProps } from '../GoSidebar.types';
import { hoverTriggerClass, bgHoverTriggerClass, gentleCurve } from './GoSidebarDesktopTab.ve.css';

interface GoSidebarDesktopTabProps extends GoTabProps {
    withoutBackground?: boolean;
}

export const GoSidebarDesktopTab = ({
    label,
    Icon,
    isActive = false,
    href,
    withoutBackground = false,
}: GoSidebarDesktopTabProps) => (
    <Container
        as="a"
        href={href}
        display="flex"
        direction="column"
        position="relative"
        minWidth="62px"
        borderRadius="lg"
        cursor="pointer"
        transition={`${gentleCurve} 0.15s`}
        style={{
            textDecoration: 'none',
            backgroundColor: isActive ? theme.colors.grey1100 : 'transparent',
            color: isActive ? theme.colors.textOnDark : theme.colors.grey700,
        }}
        className={cn(hoverTriggerClass, { [bgHoverTriggerClass]: !withoutBackground })}
    >
        <Stack
            direction="column"
            gap="2"
            alignItems="center"
            paddingX="0.5"
            paddingBottom="2"
            paddingTop="2.5"
            zIndex="1"
        >
            <Icon size={24} />
            <Typography size="b_xxs" fontWeight="semibold" lineHeight="b_xxs" transition={`${gentleCurve} 0.15s`}>
                {label}
            </Typography>
        </Stack>
    </Container>
);
